import { getViolationString, IPolicyInfoRuleResultInfoViolationInfo, PolicyViolationInfoPredicate } from 'obt-common';
import { useTranslation } from 'react-i18next';

export function useSubViolationText() {
  const { t: tCommon } = useTranslation('COMMON');
  const { t: tt } = useTranslation('WEB');
  function getSubViolationText(subViolation: IPolicyInfoRuleResultInfoViolationInfo | undefined): string | undefined {
    if (!subViolation) {
      return undefined;
    }

    const predicates: Record<number, string> = {
      [PolicyViolationInfoPredicate.FARE_MORE_THAN_MINIMUM]: tt('more than the lowest fare'),
      [PolicyViolationInfoPredicate.FARE_MORE_THAN_MEDIAN]: tt('more than the median fare'),
      [PolicyViolationInfoPredicate.FARE_LESS_THAN_MEDIAN]: tt('less than the median fare'),
    };
    const zeroBasedSubViolationText: Record<number, string> = {
      [PolicyViolationInfoPredicate.FARE_MORE_THAN_MINIMUM]: tt(
        'Calculated as the lowest fare for the selected cabin class',
      ),
      [PolicyViolationInfoPredicate.FARE_MORE_THAN_MEDIAN]: tt(
        'Calculated as the median fare for the selected cabin class',
      ),
      [PolicyViolationInfoPredicate.FARE_LESS_THAN_MEDIAN]: tt(
        'Calculated as the median fare for the selected cabin class',
      ),
    };
    if (subViolation?.predicate) {
      if (subViolation.expectedValue?.percentage === 0 || subViolation.expectedValue?.money?.amount === 0) {
        return zeroBasedSubViolationText[subViolation?.predicate];
      }
      return tt('Calculated as {{value}} {{predicateText}} for the selected cabin class', {
        value: getViolationString({ value: subViolation.expectedValue, t: tCommon }),
        predicateText: predicates[subViolation?.predicate],
      });
    }
    return undefined;
  }
  return { getSubViolationText };
}
